import { render, staticRenderFns } from "./RsSurveyHeader.vue?vue&type=template&id=6d21080c&scoped=true"
import script from "./RsSurveyHeader.vue?vue&type=script&lang=js"
export * from "./RsSurveyHeader.vue?vue&type=script&lang=js"
import style0 from "./RsSurveyHeader.vue?vue&type=style&index=0&id=6d21080c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d21080c",
  null
  
)

export default component.exports